(function ($) {
  const processBlogBody = (bodyClass, readMinutesClass, containerClass) => {
    const blogBody = $(bodyClass);
    const blogIntro = blogBody.find('p:eq(0)');
    const blogReadMinutes = parseInt($(readMinutesClass).html());
    const backToTop = $('.backToTop');
    const container = $(containerClass);

    const buildOverview = () => {
      blogIntro.after(`
        <div class='blogContentOverview'>
          <span class='blogContentOverview__title'>Snel naar inhoud gaan</span>
          <ul class='blogContentTable'></ul>
        </div>
      `);
    }

    const addToContentTable = (element, index, prefix, className = '') => {
      const elementID = `${prefix}_${index}`;
      $(element).attr('id', elementID);

      const blogContentTableRow = $('<li>').addClass('blogContentTableRow').addClass(className);
      const blogContentTableRowLink = $('<a>', {
        text: $(element).text(),
        href: `#${elementID}`,
        title: $(element).text()
      });

      blogContentTableRowLink.appendTo(blogContentTableRow);
      $('.blogContentTable').append(blogContentTableRow);

      blogContentTableRowLink.click((e) => {
        e.preventDefault();
        const aid = $(e.target).attr("href");
        $('html,body').animate({ scrollTop: $(aid).offset().top - 140 }, 'slow');
      });
    }

    const initContentTable = () => {
      let h2Index = 0;
      let h3Index = 0;

      // Select only direct children of blogBody
      const headings = blogBody.children('h2, h3.quicklink');
      headings.each((index, element) => {
        if ($(element).is('h2')) {
          h2Index++;
          h3Index = 0; // Reset h3 index for each new h2
          addToContentTable(element, h2Index, "h2");
        } else if ($(element).is('h3.quicklink')) {
          h3Index++;
          addToContentTable(element, h3Index, "h3", 'blogContentTableRow--indent');
        }
      });
    }

    const setupBackToTop = () => {
      backToTop.click((e) => {
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 'slow');
      });

      $(window).scroll(() => {
        if ($(window).scrollTop() > 500) {
          backToTop.addClass('visible');
        } else {
          backToTop.removeClass('visible');
        }
      });
    }

    // Initialize everything
    if (blogReadMinutes > 4 || container.hasClass('has-contentTable')) {
      buildOverview();
      initContentTable();
    }
    setupBackToTop();
  }

  // Call the function for both classes
  processBlogBody('.rugaandoeningBody', '.rugaandoeningReadMinutes', '.nodeBlog');
  processBlogBody('.blogBody', '.blogReadMinutes', '.nodeBlog');

})(jQuery); 